import React from 'react';
import { Box, Button } from '@mui/material';
import './SubTitle.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function MonitorSubtitle({
    title,
    path,
    add,
    addPath,
    track,
    trackPath,
    onAddClick,
    onTrackClick,
    breadcrumbHandlers = {},
}) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const getBreadcrumbNavigationTarget = (pathSegment, index, segments) => {
        const trimmedSegment = pathSegment.trim();

        if (index === 0) return { to: '/dashboard' };
        if (index === segments.length - 1) return null;

        const customHandler = breadcrumbHandlers[trimmedSegment];
        if (customHandler) {
            if (typeof customHandler === 'string') return { to: customHandler };
            if (typeof customHandler === 'object' && customHandler.to) return customHandler;
        }

        const pathMap = {
            Routes: '/route',
            Vehicles: '/vehicle',
            Stops: '/stop',
            Users: '/user',
            Schedules: '/schedule',
            Reports: '/reports',
            'Data Management': '/reports/managedata',
            'Trip Replays': '/replay',
        };

        const mappedPath = pathMap[trimmedSegment];
        return mappedPath ? { to: mappedPath } : null;
    };

    const handleBreadcrumbClick = (pathSegment, index, segments) => {
        const target = getBreadcrumbNavigationTarget(pathSegment, index, segments);
        if (!target) return;
        navigate(target.to, { state: target.state, replace: target.replace });
    };

    const renderBreadcrumbs = (path) => {
        const segments = path.split('>');
        return segments.map((segment, index) => {
            const isClickable = Boolean(
                getBreadcrumbNavigationTarget(segment, index, segments)
            );
            return (
                <React.Fragment key={index}>
                    <span
                        className={`subtitle-breadcrumb ${isClickable ? 'clickable' : ''}`}
                        onClick={() => handleBreadcrumbClick(segment, index, segments)}
                    >
                        {t(segment.trim())}
                    </span>
                    {index < segments.length - 1 && (
                        <span className="subtitle-separator"> &gt; </span>
                    )}
                </React.Fragment>
            );
        });
    };

    const handleAddClick = () => {
        if (onAddClick) onAddClick(addPath);
    };

    const handleTrackClick = () => {
        if (onTrackClick) onTrackClick(trackPath);
    };

    return (
        <div className="subtitle-container">
            <div className="subtitle-left-content">
                <Box>
                    <span className="subtitle-text">{t(title)}</span>
                    <div className="subtitle-path">{renderBreadcrumbs(path)}</div>
                </Box>
            </div>

            <div className="subtitle-buttons">
                {track && (
                    <Button
                        sx={{
                            color: "#FFFFFF",
                            width: { xs: "100%", sm: "188px" },
                            height: "55px",
                            borderRadius: "8px",
                            padding: "12px 24px",
                            gap: "10px",
                            textTransform: "none",
                            "&:hover": { background: "#1A8FC0" }
                        }}
                        onClick={handleTrackClick}
                        style={{
                            height: "55px",
                            borderRadius: "8px",
                            border: "2px solid #20A8E0",
                            padding: "10px 20px",
                            color: "#20A8E0",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            fontSize: "20px",
                            transition: "all 0.3s ease",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {t(track)}
                    </Button>
                )}

                {add && (
                    <Button
                        onClick={handleAddClick}
                        variant="contained"
                        sx={{
                            color: "#FFFFFF",
                            width: { xs: "100%", sm: "200px" },
                            height: "55px",
                            borderRadius: "8px",
                            padding: "12px 20px",
                            gap: "10px",
                            background: "#20A8E0",
                            textTransform: "none",
                            "&:hover": { background: "#1A8FC0" },
                            fontFamily: "Roboto",
                            fontWeight: 600,
                            fontSize: "20px"
                        }}
                    >
                        {t(add)}
                    </Button>
                )}
            </div>
        </div>
    );
}